import Vue from "vue";
import VueI18n from "vue-i18n";
import ru from "../locales/ru";
import kz from "../locales/kz";

Vue.use(VueI18n);

const savedLocale = localStorage.getItem("userLang") || "ru";

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: "ru",
  messages: {
    ru,
    kz
  }
});

export default i18n;
